(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			if (typeof Swiper === "undefined") return;
			if (slideshow.swiper && !slideshow.swiper.destroyed) {
				slideshow.swiper.destroy(true, true);
			}

			const autoplay =
				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
			const slideshowSwiper = new Swiper(slideshow, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        autoHeight: false,
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      });
			if (autoplay) {
				slideshowSwiper.autoplay.run();
				slideshowSwiper.autoplay.running = true;

				slideshow.onmouseenter = () => {
					slideshowSwiper.autoplay.pause();
				};
				slideshow.onmouseleave = () => {
					slideshowSwiper.autoplay.run();
				};
			} else {
				slideshow.onmouseenter = null;
				slideshow.onmouseleave = null;
			}
			if (slideshowSwiper.slides.length < 2) {
				slideshowSwiper.allowTouchMove = false;
			} else {
				slideshowSwiper.allowTouchMove = true;
			}
			if (slideshowSwiper.slides.length > 1)
				slideshow.classList.add("slideshow__swiper--multiple-slides");
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
